import React from 'react';
import {injectIntl, intlShape} from 'react-intl';
import moment from 'moment-timezone';
import get from 'lodash/get';
import AutoSaveField from './abstract/AutoSaveField.jsx';

import {DateTimePicker} from 'react-widgets';
import momentLocalizer from 'react-widgets-moment';
import {isNoU} from "utils/DBUtils";
import {forceConvertLocalTime, getTzWithLang} from "utils/time";

class AutoSaveDateTimePicker extends React.Component {
  constructor(props) {
    super(props);
    moment.locale('en');
    momentLocalizer();

    this.state = {
      savedDefaultValue: false
    };
  }

  componentWillReceiveProps(nextProps) {
    // dates are returned from the API as either numbers (timestamps) or strings, so if we receive
    // a moment instance it's a new default value intended for auto-populating this field.
    if (moment.isMoment(nextProps.defaultValue)) {
      const value = this.getValueFromOnChange(nextProps.defaultValue);
      this.props.onValueChanged(value, this.props.name);
    }
  }

  // Convenience method for converting a timestamp value to a moment time with current lang's timezone
  // If no lang is given, moment defaults to local timezone
  tzMoment = (value) => {
    let date = moment(value);
    if (this.props.lang) {
      let tz = getTzWithLang(this.props.lang);
      date = date.tz(tz);
    }
    return date;
  };

  getValueFromOnChange = (value) => {
    let val = value;
    // fill with previous value instead of trying to send an empty value
    if (this.props.required && isNoU(value)) {
      val = this.props.defaultValue;
    }

    // If we have a value
    // and a time snap prop to check
    if (!isNoU(val) && !isNoU(this.props.timeSnap)) {

      // new value will be in local time
      // need to enforce selected timezone
      // convert both new and old values for comparison purposes
      let newDate = this.tzMoment(val);

      // If new date then snap time
      if (isNoU(this.props.defaultValue)) {
        // need separate check because
        // if selecting the current day and defaultValue is null
        // oldDate (below) would be today as well, resulting in the below check being passed over
        this.snapTime(newDate);
      } else {
        // If the date has changed
        // set date's time to timeSnap value

        let oldDate = this.tzMoment(this.props.defaultValue);

        if ((newDate.date() !== oldDate.date()
          || newDate.month() !== oldDate.month()
          || newDate.year() !== oldDate.year())) {
          this.snapTime(newDate);
        }
      }

      val = newDate;
    }

    // return null instead of trying to convert a null value which would result in NaN
    return isNoU(val) ? null : moment(val).unix() * 1000; // need to convert date to millis timestamp for api t save
  };

  snapTime = date => {
    date.hour(this.props.timeSnap.hour);
    date.minute(this.props.timeSnap.minute);
    date.second(this.props.timeSnap.second);
    date.millisecond(this.props.timeSnap.millisecond);
  };

  render() {
    let selectedDate = null;

    if (!isNoU(this.props.defaultValue)) {
      // Convert utc timestamp to timezone needed for what ever we're saving
      let tzDate = this.tzMoment(this.props.defaultValue);

      // need to create a new moment from without timezone
      // effectively converting it to local time
      // to display as if we were in the selected timezone
      selectedDate = forceConvertLocalTime(tzDate).toDate();
    }

    const placeholderKey = get(this.props, 'field.placeholderKey', null);
    const placeholderText = placeholderKey ? this.props.intl.formatMessage({id: placeholderKey}) : '';

    return (
      <div className='ui input'>
        <AutoSaveField
          {...this.props}
          control={DateTimePicker}
          value={selectedDate}
          getValueFromOnChange={this.getValueFromOnChange}
          placeholder={placeholderText}
          className="autosave-date-time-picker"
          culture={this.props.lang || "en-US"}/>
      </div>
    );
  }
}

AutoSaveDateTimePicker.propTypes = {
  intl: intlShape.isRequired
};

export default injectIntl(AutoSaveDateTimePicker);



// WEBPACK FOOTER //
// ./public/components/forms/AutoSaveFormFields/AutoSaveDateTimePicker.jsx